module.exports = __webpack_public_path__ + "media/images/cz10-5d391efd008c74af56671aa933ac6438.svg";